import React, { useContext, useEffect } from "react";
import ReactGA from "react-ga";

import { Router, Route, Switch } from "react-router-dom";

/* local components */
import Home from "./components/Session/Home";
import Login from "./components/Session/Login";
import Logout from "./components/Session/Logout";
import PrivateRoute from "./components/Session/PrivateRoute";
import Recovery from "./components/Session/Recovery";
import Register from "./components/Session/Register";
import Admin from "./components/Admin";
import StylePlayground from "./components/StylePlayground";
import MapPlayground from "./components/MapPlayground";

/* context for hooks */
import { SessionContext } from "./context/SessionContext";

const App = () => {
  const { browserHistory } = useContext(SessionContext);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <React.Fragment>
      <Router history={browserHistory}>
        <Route path="/logout" component={Logout} />

        <Switch>
          <Route path="/login" component={Login} />
          <Route path="/signup" component={Register} />
          <Route path="/recovery" component={Recovery} />
          <PrivateRoute path="/admin" component={Admin} />
          <Route path="/style-playground" component={StylePlayground} />
          <PrivateRoute path="/map-playground" component={MapPlayground} />
          <PrivateRoute path="/" component={Home} />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export default App;
